import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {
  constructor() {
    if (!this.isSupported('localStorage') || !this.isSupported('sessionStorage'))
      throw new Error('The current client does not implement HTML5 storage API');
  }

  private isSupported(storage: 'localStorage' | 'sessionStorage'): boolean {
    try {
      return storage in window && window[storage] !== null;
    } catch (e) {
      return false;
    }
  }

  public clearAll(): boolean {
    try {
      for (let key in localStorage) {
        localStorage.removeItem(key);
      }
      for (let key in sessionStorage) {
        sessionStorage.removeItem(key);
      }
    } catch (e) {
      return false;
    }
    return true;
  }

  getValue(key: string, perSession: boolean = false): string {
    if (perSession) {
      return sessionStorage.getItem(key);
    } else {
      return localStorage.getItem(key);
    }
  }

  public removeValue(key: string, perSession: boolean) {
    if (perSession) {
      sessionStorage.removeItem(key);
    } else {
      localStorage.removeItem(key);
    }
  }

  public set(key: string, value: any, perSession: boolean = false): boolean {
    if (value === undefined) {
      value = null;
    }
    try {
      if (perSession) {
        sessionStorage.setItem(key, value);
      } else {
        localStorage.setItem(key, value);
      }
    } catch (e) {
      return false;
    }
    return true;
  }
}
